import { ScanPatientContent } from "@/features/scans/components/ScanPatientContent"
import { useParams } from "react-router-dom"

export default function ScanPatientPage() {
  const { patientId } = useParams()

  return <ScanPatientContent patientId={patientId!}/>
}